import { generateId } from '@repo/shared/uuid/uuid'
import { useT } from '@repo/ui/hooks'
import { useEffect } from 'react'

import { PromptEditorLight } from '@/components/admin/PromptEditorLight'
import { AssistantWrapper } from '@/components/assistant/AssistantWrapper'
import { RightPanel } from '@/components/layouts/panels/RightPanel'
import { adminStoreActions, storeActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { Organization } from '@/store/user'

export function MethodologyRoute({ organization }: { organization: Organization }) {
  const { tc, t } = useT({ keyPrefix: 'admin.methodology' })
  const dispatch = useStoreDispatch()
  const handlePromptUpdated = (methodology: string) => {
    void dispatch(
      adminStoreActions.organization.update({
        fields: { methodology },
      }),
    )
  }
  useEffect(() => {
    dispatch(
      storeActions.assistant.askFor.organization.methodology.start({
        generationId: generateId(),
      }),
    )
  }, [])
  return (
    <div className="grid grid-cols-2 gap-4 2xl:gap-6 w-full">
      <PromptEditorLight
        key="methodology"
        initialPrompt={organization.methodology}
        description={t('description')}
        onPromptUpdated={handlePromptUpdated}
        placeholder={t('placeholder')}
        title={tc('methodology', { cfl: true })}
      />

      <RightPanel
        className="max-w-full 2xl:max-w-full m-0 2xl:m-0 max-h-full overflow-hidden overflow-y-auto"
        status="fixed"
      >
        <AssistantWrapper />
      </RightPanel>
    </div>
  )
}
